import React, { useEffect, useState } from 'react'

import { Tooltip } from '@material-ui/core'
import {
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  TableFooter,
  CheckBox
} from 'components'
import { BlockIcon, LockIcon, StatusIcon } from 'components/Icons'
import { useLoading, useModal } from 'hooks'
import {
  FolhaRegistroResponseDTO,
  RecordsSheetGetBlock
} from 'services/NGT/RecordsSheet'
import { COLORS, FORMAT, SPACING } from 'utils'
import { Check } from '@mui/icons-material'
import { spacing } from 'react-select/src/theme'

interface ITableSearchRecordsSheetForm {
  tableData: FolhaRegistroResponseDTO[]
  checkedCheckbox: any[]
  setCheckedCheckbox: any
  isBlock: boolean
  isConsult: boolean
  setTableDataStatus?: (ob: any) => void
  tipo: 'Bloqueio' | 'Liberacao'
  isLoading?: boolean // ← Adicione esta prop
}

const TableSearchRecordsSheetForm: React.FC<ITableSearchRecordsSheetForm> = ({
  tableData = [],
  checkedCheckbox,
  setCheckedCheckbox,
  isBlock,
  isConsult,
  setTableDataStatus,
  tipo,
  isLoading = false
}) => {

  const [page, setPage] = useState<number>(0)
  const [rowsPerPage, setRowsPerPage] = useState<number>(15)
  const [checkAllState, setCheckAllState] = useState<boolean>(false)
  const [totalVlLiquidoLiberadas, settotalVlLiquidoLiberadas] =
    useState<boolean>(false)
  const { setLoading } = useLoading()
  const { showModal } = useModal()

  const handleChangePage = (newPage: number) => setPage(newPage)

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const getCheckedItens = (): number[] => {
    return checkedCheckbox.map(
      (folhaRegistro: FolhaRegistroResponseDTO) => folhaRegistro.idFolhaRegistro
    )
  }

  const checkValue = (row: FolhaRegistroResponseDTO) => {

    // Para tipo "Bloqueio": não permitir seleção se txBloqueioPagamento é "O"
    if (tipo === 'Bloqueio' && row.txBloqueioPagamento === "O") {
      return;
    }

    if (getCheckedItens().includes(row.idFolhaRegistro)) {
      setCheckedCheckbox((prevState: FolhaRegistroResponseDTO[]) =>
        prevState.filter(
          (value: FolhaRegistroResponseDTO) =>
            value.idFolhaRegistro !== row.idFolhaRegistro
        )
      )
      return
    }
    setCheckedCheckbox((prevState: FolhaRegistroResponseDTO[]) => [
      ...prevState,
      row
    ])
  }

  const checkAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      if (tipo && tipo === 'Bloqueio') {
        // Para Bloqueio: excluir itens já bloqueados E itens com bloqueio "O"
        setCheckedCheckbox(tableData.filter((folha) => !folha.flBloqPagamento && folha.txBloqueioPagamento !== "O"))
      } else {
        // Para Liberação: incluir todos os itens bloqueados (inclusive com bloqueio "O")
        setCheckedCheckbox(tableData.filter((folha) => folha.flBloqPagamento))
      }
      setCheckAllState(true)
      return
    }
    setCheckedCheckbox([])
  }

  // const totalLiquidoFR = tableData.reduce(
  // (total: number, folhaRegistro: FolhaRegistroResponseDTO) => total + folhaRegistro.vlLiquido,
  // 0,
  // );

  useEffect(() => {
    if (!tableData) return
    const folhasBloqueadas = tableData.filter(
      (folha) => folha.flBloqPagamento === true && folha.idBloqueio != 0
    )
    if (folhasBloqueadas && folhasBloqueadas.length > 0) {
      settotalVlLiquidoLiberadas(true)
    } else settotalVlLiquidoLiberadas(false)
  }, [tipo])

  const totalLiquidoFrAtualizado = () => {
    if (!totalVlLiquidoLiberadas) {
      const totalLiquidoFR = tableData.reduce(
        (total: number, folhaRegistro: FolhaRegistroResponseDTO) =>
          total + folhaRegistro.vlLiquido,
        0
      )
      return totalLiquidoFR
    } else {
      const totalLiquidoFR = deduplicatedData.reduce(
        (total: number, folhaRegistro: FolhaRegistroResponseDTO) =>
          total + folhaRegistro.vlLiquido,
        0
      )
      return totalLiquidoFR
    }
  }

  useEffect(() => {
    if (checkedCheckbox.length === 0) {
      setCheckAllState(false)
    }
  }, [checkedCheckbox])

  const handlePutStatusFRSAP = (id: number) => {
    setLoading('loading')

    RecordsSheetGetBlock()
      .PutBloquearFRSAP(id)
      .then(() => {
        setTableDataStatus((prevState) => ({
          ...prevState,
          folhasRegistro: [
            ...prevState?.folhasRegistro?.map((folhaRegistro) =>
              folhaRegistro.idFolhaRegistro === id
                ? {
                  ...folhaRegistro,
                  flBloqueadoSAP: !folhaRegistro.flBloqueadoSAP
                }
                : { ...folhaRegistro }
            )
          ]
        }))
        setLoading('idle')
      })
      .catch(() => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message:
            'Ocorreu um erro ao tentar mudar status da folha de registro',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const handleStatus = (status: boolean) => {
    if (!status) return 'Liberar'
    else return 'Bloquear'
  }

  // Função para remover duplicatas
  const removeDuplicates = (data: FolhaRegistroResponseDTO[]) => {
    const uniqueIds = new Set()
    return data.filter((item) => {
      if (uniqueIds.has(item.idFolhaRegistro)) {
        return false
      } else {
        uniqueIds.add(item.idFolhaRegistro)
        return true
      }
    })
  }

  const deduplicatedData = removeDuplicates(tableData || [])
  const paginatedData = deduplicatedData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  )

  if (isLoading) {
    return (
      <>
        {deduplicatedData.length > 0 ? (
          <TableContainerStyled>
            <TableStyled>
              <TableHeadStyled>
                <TableRowStyled>
                  <TableCellStyled>
                    <CheckBox
                      onClick={checkAll}
                      disabled={isConsult}
                      checked={checkAllState}
                    />
                  </TableCellStyled>
                  <TableCellStyled>Contrato</TableCellStyled>
                  <TableCellStyled align="center">Centro Planta</TableCellStyled>
                  <TableCellStyled align="center">Referência</TableCellStyled>
                  <TableCellStyled align="center">Nº Documento</TableCellStyled>
                  <TableCellStyled align="center">
                    Nº Folha Registro
                  </TableCellStyled>
                  <TableCellStyled align="center">Tp. Doc.</TableCellStyled>
                  <TableCellStyled align="center">Bloq. Pagto.</TableCellStyled>
                  <TableCellStyled align="center">Form. Pagto.</TableCellStyled>
                  <TableCellStyled align="center">Valor Bruto</TableCellStyled>
                  <TableCellStyled align="center">Valor Líquido</TableCellStyled>
                  <TableCellStyled align="center">Vencimento</TableCellStyled>
                  <TableCellStyled align="center">Descrição</TableCellStyled>
                  <TableCellStyled align="center">Status SAP</TableCellStyled>
                  <TableCellStyled align="center">Ações</TableCellStyled>
                </TableRowStyled>
              </TableHeadStyled>
              <TableBodyStyled>
                {paginatedData.map((row: FolhaRegistroResponseDTO) => (
                  <TableRowStyled key={row.idFolhaRegistro}>
                    <TableCellStyled>
                      <CheckBox
                        disabled={
                          (row.flBloqPagamento && isBlock) ||
                          (!row.flBloqPagamento && !isBlock) ||
                          isConsult ||
                          row.txBloqueioPagamento === "O" // Nova condição
                        }
                        checked={getCheckedItens().includes(row.idFolhaRegistro)}
                        onClick={() => checkValue(row)}
                      />
                    </TableCellStyled>
                    <TableCellStyled>{row?.cdContrato}</TableCellStyled>
                    <TableCellStyled align="center">
                      {row?.nmCentroPlanta || '- - - - -'}
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      {row?.txReferencia || '- - - - -'}
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      {row?.txNumeroDocumento || '- - - - -'}
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      {row?.cdFolhaRegistroSRV || '- - - - -'}
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      {row?.dsTipoDocumento || '- - - - -'}
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      {row?.flBloqPagamento ? 'Bloqueado' : 'Ativo'}
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      {row?.dsFormaPagamento || '- - - - -'}
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      {FORMAT.currency(row?.vlBruto)}
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      {FORMAT.currency(row?.vlLiquido)}
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      {FORMAT.formatDDMMYYYY(row?.dtVencimento)}
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      {row?.txDescricao || '- - - - -'}
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      <StatusIcon
                        colorIcon={
                          !row.flBloqueadoSAP ? COLORS.success : COLORS.error
                        }
                        marginLeft={SPACING.spacing50}
                      />
                    </TableCellStyled>
                    <Tooltip
                      arrow
                      title={handleStatus(row.flBloqueadoSAP)}
                      placement="left"
                    >
                      <TableCellStyled align="center">
                        {!row.flBloqueadoSAP ? (
                          <LockIcon
                            cursor="pointer"
                            disabled={row.flImportadoSAP}
                            onClick={() =>
                              handlePutStatusFRSAP(row.idFolhaRegistro)
                            }
                          />
                        ) : (
                          <BlockIcon
                            disabled={row.flImportadoSAP}
                            marginRight={SPACING.spacing5}
                            cursor="pointer"
                            onClick={() =>
                              handlePutStatusFRSAP(row.idFolhaRegistro)
                            }
                          />
                        )}
                      </TableCellStyled>
                    </Tooltip>
                  </TableRowStyled>
                ))}
                <TableRowStyled style={{ background: COLORS.lightGray }}>
                  <TableCellStyled />
                  {totalVlLiquidoLiberadas ? (
                    <TableCellStyled style={{ whiteSpace: 'nowrap' }}>
                      TOTAL DAS FRS DISPONÍVEIS PARA LIBERAÇÃO:
                    </TableCellStyled>
                  ) : (
                    <TableCellStyled>TOTAL:</TableCellStyled>
                  )}
                  <TableCellStyled />
                  <TableCellStyled />
                  <TableCellStyled />
                  <TableCellStyled />
                  <TableCellStyled />
                  <TableCellStyled />
                  <TableCellStyled />
                  <TableCellStyled />
                  <TableCellStyled align="center">
                    {FORMAT.currency(totalLiquidoFrAtualizado())}
                  </TableCellStyled>
                  <TableCellStyled />
                  <TableCellStyled />
                  <TableCellStyled />
                  <TableCellStyled />
                </TableRowStyled>
              </TableBodyStyled>
            </TableStyled>
          </TableContainerStyled>
        ) : (
          <TableContainerStyled>
            <TableStyled>
              <TableHeadStyled>
                <TableRowStyled>
                  {!(tipo == 'Bloqueio') ? (
                    <TableCellStyled align="center">
                      Não foram encontradas Folhas de Registros disponíveis para
                      liberação desse fornecedor.
                    </TableCellStyled>
                  ) : (
                    <TableCellStyled align="center">
                      Não foram encontradas folhas de registros para este
                      contrato.
                    </TableCellStyled>
                  )}
                </TableRowStyled>
              </TableHeadStyled>
            </TableStyled>
          </TableContainerStyled>
        )}
        <TableFooter
          page={page}
          rows={tableData}
          typeFooter="offline"
          rowsPerPage={rowsPerPage}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </>
    )
  }
  else {
    return (
      <>
        {deduplicatedData.length > 0 ? (
          <TableContainerStyled>
            <TableStyled>
              <TableHeadStyled>
                <TableRowStyled>
                  <TableCellStyled>
                    <CheckBox
                      onClick={checkAll}
                      disabled={isConsult}
                      checked={checkAllState}
                    />
                  </TableCellStyled>
                  <TableCellStyled>Contrato</TableCellStyled>
                  <TableCellStyled align="center">Centro Planta</TableCellStyled>
                  <TableCellStyled align="center">Referência</TableCellStyled>
                  <TableCellStyled align="center">Nº Documento</TableCellStyled>
                  <TableCellStyled align="center">
                    Nº Folha Registro
                  </TableCellStyled>
                  <TableCellStyled align="center">Tp. Doc.</TableCellStyled>
                  <TableCellStyled align="center">Bloq. Pagto.</TableCellStyled>
                  <TableCellStyled align="center">Form. Pagto.</TableCellStyled>
                  <TableCellStyled align="center">Valor Bruto</TableCellStyled>
                  <TableCellStyled align="center">Valor Líquido</TableCellStyled>
                  <TableCellStyled align="center">Vencimento</TableCellStyled>
                  <TableCellStyled align="center">Descrição</TableCellStyled>
                  <TableCellStyled align="center">Status SAP</TableCellStyled>
                  <TableCellStyled align="center">Ações</TableCellStyled>
                </TableRowStyled>
              </TableHeadStyled>
              <TableBodyStyled>
                {paginatedData.map((row: FolhaRegistroResponseDTO) => {
                  const condition1 = row.flBloqPagamento && isBlock
                  const condition2 = !row.flBloqPagamento && !isBlock
                  const condition3 = isConsult
                  const condition4 = row.txBloqueioPagamento === "O" && tipo === 'Bloqueio'

                  const finalDisabled = condition1 || condition2 || condition3 || condition4

                  return (
                    <TableRowStyled key={row.idFolhaRegistro}>
                      <TableCellStyled>
                        <CheckBox
                          disabled={finalDisabled}
                          checked={getCheckedItens().includes(row.idFolhaRegistro)}
                          onClick={() => checkValue(row)}
                        />
                      </TableCellStyled>
                      <TableCellStyled>{row?.cdContrato}</TableCellStyled>
                      <TableCellStyled align="center">
                        {row?.nmCentroPlanta || '- - - - -'}
                      </TableCellStyled>
                      <TableCellStyled align="center">
                        {row?.txReferencia || '- - - - -'}
                      </TableCellStyled>
                      <TableCellStyled align="center">
                        {row?.txNumeroDocumento || '- - - - -'}
                      </TableCellStyled>
                      <TableCellStyled align="center">
                        {row?.cdFolhaRegistroSRV || '- - - - -'}
                      </TableCellStyled>
                      <TableCellStyled align="center">
                        {row?.dsTipoDocumento || '- - - - -'}
                      </TableCellStyled>
                      <TableCellStyled align="center">
                        {row?.flBloqPagamento ? 'Bloqueado' : 'Ativo'}
                      </TableCellStyled>
                      <TableCellStyled align="center">
                        {row?.dsFormaPagamento || '- - - - -'}
                      </TableCellStyled>
                      <TableCellStyled align="center">
                        {FORMAT.currency(row?.vlBruto)}
                      </TableCellStyled>
                      <TableCellStyled align="center">
                        {FORMAT.currency(row?.vlLiquido)}
                      </TableCellStyled>
                      <TableCellStyled align="center">
                        {FORMAT.formatDDMMYYYY(row?.dtVencimento)}
                      </TableCellStyled>
                      <TableCellStyled align="center">
                        {row?.txDescricao || '- - - - -'}
                      </TableCellStyled>
                      <TableCellStyled align="center">
                        <StatusIcon
                          colorIcon={
                            !row.flBloqueadoSAP ? COLORS.success : COLORS.error
                          }
                          marginLeft={SPACING.spacing50}
                        />
                      </TableCellStyled>
                      <Tooltip
                        arrow
                        title={handleStatus(row.flBloqueadoSAP)}
                        placement="left"
                      >
                        <TableCellStyled align="center">
                          {!row.flBloqueadoSAP ? (
                            <LockIcon
                              cursor="pointer"
                              disabled={row.flImportadoSAP}
                              onClick={() =>
                                handlePutStatusFRSAP(row.idFolhaRegistro)
                              }
                            />
                          ) : (
                            <BlockIcon
                              disabled={row.flImportadoSAP}
                              marginRight={SPACING.spacing5}
                              cursor="pointer"
                              onClick={() =>
                                handlePutStatusFRSAP(row.idFolhaRegistro)
                              }
                            />
                          )}
                        </TableCellStyled>
                      </Tooltip>
                    </TableRowStyled>
                  );
                })}
                <TableRowStyled style={{ background: COLORS.lightGray }}>
                  <TableCellStyled />
                  {totalVlLiquidoLiberadas ? (
                    <TableCellStyled style={{ whiteSpace: 'nowrap' }}>
                      TOTAL DAS FRS DISPONÍVEIS PARA LIBERAÇÃO:
                    </TableCellStyled>
                  ) : (
                    <TableCellStyled>TOTAL:</TableCellStyled>
                  )}
                  <TableCellStyled />
                  <TableCellStyled />
                  <TableCellStyled />
                  <TableCellStyled />
                  <TableCellStyled />
                  <TableCellStyled />
                  <TableCellStyled />
                  <TableCellStyled />
                  <TableCellStyled align="center">
                    {FORMAT.currency(totalLiquidoFrAtualizado())}
                  </TableCellStyled>
                  <TableCellStyled />
                  <TableCellStyled />
                  <TableCellStyled />
                  <TableCellStyled />
                </TableRowStyled>
              </TableBodyStyled>
            </TableStyled>
          </TableContainerStyled>
        ) : (
          <TableContainerStyled>
            <TableStyled>
              <TableHeadStyled>
                <TableRowStyled>
                  {!(tipo == 'Bloqueio') ? (
                    <TableCellStyled align="center">
                      Não foram encontradas Folhas de Registros disponíveis para
                      liberação desse fornecedor.
                    </TableCellStyled>
                  ) : (
                    <TableCellStyled align="center">
                      Não foram encontradas folhas de registros para este
                      contrato.
                    </TableCellStyled>
                  )}
                </TableRowStyled>
              </TableHeadStyled>
            </TableStyled>
          </TableContainerStyled>
        )}
        <TableFooter
          page={page}
          rows={tableData}
          typeFooter="offline"
          rowsPerPage={rowsPerPage}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </>
    )
  }
}

export default TableSearchRecordsSheetForm